var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestToJoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4L5.6 5.4 8.2 8H0v2h8.2l-2.6 2.6L7 14l5-5-5-5zm9 12H8v2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2H8v2h8v14z",
    fill: "#687587"
  })));
}
export default SvgRequestToJoin;